const gridProfile = {
  gridProfile: {
    pageHeader: 'Profilo rete',
    name: 'Nome',
    description: 'Descrizione',
    createdBy: 'Creato da',
    noGrid: '** Nessuna rete disponibile **',
    grids: 'Reti'
  }
};

export default gridProfile;
